import { render, staticRenderFns } from "./STablePaymentComp.vue?vue&type=template&id=285dbbab&"
import script from "./STablePaymentComp.vue?vue&type=script&lang=js&"
export * from "./STablePaymentComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports